/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notfound_Actions_Contact_SupportInputs */



/**
* | output |
* | --- |
* | "Contact Support" |
*
* @param {Notfound_Actions_Contact_SupportInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notfound_actions_contact_support = /** @type {((inputs?: Notfound_Actions_Contact_SupportInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notfound_Actions_Contact_SupportInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Support kontaktieren")
	return /** @type {LocalizedString} */ ("Contact Support")
});